(ns ui.wallet.i18n.tr
  "Turkish dictionary of the wallet page (see `ui.wallet.i18n`).")

(def dictionary
  {:page/loading "yükleniyor..."
   :page/command-failed "Bir sorun oluştu. Lütfen tekrar deneyin; devam ederse sohbetten bize yazın."

   :balance/total-available "Kullanılabilir bakiye"
   :balance/pay-as-you-go "Kullandıkça öde bakiyesi"
   :balance/used-up "Paylaşmaya devam etmek için kredi ekleyin."
   :balance/view-usage "Kullanımı görüntüle"

   :payment/title "Ödeme"
   :payment/method "Ödeme yöntemi"
   :payment/billing-email "Fatura e-postası"
   :payment/reference "Referans"
   :payment/update "Ödeme yöntemini değiştir"
   :payment/card [:fn/str "Kart ({{:last4}})"]
   :payment/wire-transfer "Havale"

   :billing-email/change "Değiştir"
   :billing-email/new "Yeni fatura e-postası"
   :billing-email/save "Kaydet"
   :billing-email/saving "Kaydediliyor..."
   :billing-email/cancel "İptal"
   :billing-email/hint "Satıcımız Paddle, makbuzları ve faturaları bu adrese gönderir."
   :billing-email/shared-hint "Bu fatura hesabını birden fazla organizasyonunuz paylaşıyorsa, değişiklik hepsi için geçerli olur."
   :billing-email/invalid "Lütfen geçerli bir e-posta adresi girin."
   :billing-email/taken "Bu e-posta adresi zaten başka bir fatura hesabı tarafından kullanılıyor. Lütfen farklı bir adres kullanın veya bize sohbetten yazın."

   :customer-conflict/title "E-postanız zaten başka bir hesaba bağlı"
   :customer-conflict/text "E-posta adresiniz zaten başka bir Storrito organizasyonunun fatura hesabına ait ve ödeme sağlayıcımız Paddle e-posta başına yalnızca bir fatura hesabına izin veriyor. Lütfen bize sohbetten yazın, sorunu sizin için çözelim."
   :customer-conflict/chat "Destek sohbetini aç"
   :customer-conflict/support-message "Merhaba, ödeme sayfasını açamıyorum: e-posta adresim zaten başka bir fatura hesabına ait."

   :top-up/title "Otomatik Yükleme"
   :top-up/custom-amount "Özel tutar"
   :top-up/opening-checkout "Ödeme açılıyor..."
   :top-up/amount-missing "Lütfen bir tutar girin."
   :top-up/amount-too-small [:fn/str "Minimum tutar ${{:minimum}}."]
   :top-up/amount-too-large [:fn/str "Yükleme başına en fazla ${{:maximum}}. Daha yüksek tutarlar için lütfen sohbetten bize yazın."]
   :top-up/per-month [:fn/str "Her ay ${{:quantity}}"]
   :top-up/per-year [:fn/str "Her yıl ${{:quantity}}"]
   :top-up/stops-on [:fn/str "{{:date}} tarihinde sona erer"]
   :top-up/next-on [:fn/str "Sonraki yükleme: {{:date}}"]
   :top-up/status-cancellation-scheduled "iptal planlandı"
   :top-up/status-payment-failed "ödeme başarısız"
   :top-up/status-active "etkin"
   :top-up/past-due "Son yükleme tahsil edilemedi. "
   :top-up/update-payment-method "Ödeme yönteminizi güncelleyin"
   :top-up/resume "Otomatik Yüklemeye devam et"
   :top-up/cancel "Otomatik Yüklemeyi iptal et"
   :top-up/paddle-unavailable "Otomatik Yükleme bilgileriniz şu anda Paddle'dan yüklenemedi. Lütfen biraz sonra tekrar deneyin."
   :top-up/try-again "Tekrar dene"

   :plan/title-monthly "Aylık yükleme"
   :plan/title-yearly "Yıllık yükleme"
   :plan/switch "Kullandıkça öde modeline geç"
   :plan/switching "Geçiliyor..."
   :plan/switch-confirm [:fn/str "${{:quantity}} tutarındaki yinelenen yüklemeniz şimdi sona eriyor; geçiş ücretsizdir. Bakiyeniz ve ödeme yönteminiz kalır. Bundan sonra yalnızca kredi eklediğinizde ödersiniz veya otomatik yüklemeyle otomatik olarak."]
   :plan/wont-cover [:fn/str "Bakiyeniz, {{:date}} tarihindeki bir sonraki yüklemeye kadar bağlı Instagram hesaplarınızı büyük olasılıkla karşılamaz; bakiye $0 olduğunda hikayeler paylaşılmaz."]
   :plan/wont-cover-advice "Aşağıdan otomatik yüklemeyi açın veya şimdi kredi ekleyin."

   :on-demand/add-credits "Kredi ekle"
   :on-demand/choose-amount "Bir tutar seçin. Yalnızca kullandığınız kadar ödersiniz."
   :on-demand/auto-top-up "Otomatik Yükleme"
   :on-demand/rule [:fn/str "Bakiyeniz ${{:threshold}} altına düştüğünde otomatik olarak ${{:amount}} ekleriz."]
   :on-demand/auto-top-up-hint "İsteğe bağlı. Bakiyen azaldığında hikayelerin paylaşılmaya devam eder; istediğin zaman kapatabilirsin."
   :on-demand/add [:fn/str "${{:amount}} ekle"]
   :on-demand/charged-once "Satıcımız Paddle üzerinden şimdi tek seferlik tahsil edilir. Kartınız sonraki yüklemeler için kaydedilir, yinelenen bir ödeme yoktur. Krediler iade edilmez. Fiyatlara KDV dahil değildir."
   :on-demand/discount-off [:fn/str "%{{:percent}} indirim:"]
   :on-demand/discount-applied "İlk yüklemenizden itibaren günlük ücretinize uygulanır, yüklediğiniz tutara değil. Hoş geldin kredisi normal ücretle faturalandırılır."
   :on-demand/charged-to-card "Kayıtlı ödeme yönteminizden tahsil edilir, saniyeler içinde kullanılabilir."
   :on-demand/confirm-charge [:fn/str "Şimdi vergiler hariç ${{:amount}} USD tahsil edilecek."]
   :on-demand/charging "Tahsil ediliyor..."
   :on-demand/add-now [:fn/str "Şimdi ${{:amount}} ekle"]
   :on-demand/payment-accepted "Ödeme kabul edildi, bakiyeniz birkaç saniye içinde güncellenir."
   :on-demand/prices-excl-vat "Fiyatlara KDV dahil değildir."
   :on-demand/amount-too-large [:fn/str "Yükleme başına en fazla ${{:maximum}}."]
   :on-demand/on "Açık"
   :on-demand/off "Kapalı"
   :on-demand/saving "Kaydediliyor..."
   :on-demand/save "Kaydet"
   :on-demand/custom-auto-top-up-amount "Özel Otomatik Yükleme tutarı"
   :on-demand/one-charge-per-day "Günde en fazla bir otomatik tahsilat, kayıtlı ödeme yönteminizden, geçerli vergiler hariç."
   :on-demand/remove-payment-method "Ödeme yöntemini kaldır"

   :transactions/title "Son işlemler"
   :transactions/full-statement "Tam hesap özeti"
   :transactions/invoices "Faturalar"
   :transactions/date "Tarih"
   :transactions/description "Açıklama"
   :transactions/amount "Tutar"
   :transactions/error "İşlemler yüklenemedi."
   :transactions/empty "Bu ay henüz satın alma yok."
   :transactions/welcome-credits "Hoş geldin kredisi"
   :transactions/recurring-top-up "Yinelenen yükleme"
   :transactions/added-credits "Kredi eklendi"
   :transactions/refund "Kredi iadesi"

   :credit-notes/view "Alacak dekontları"
   :credit-notes/title "Alacak dekontları"
   :credit-notes/intro "İadeleriniz ve alacaklarınız için alacak dekontları. Bayimiz Paddle tarafından düzenlenir."
   :credit-notes/refund "İade"
   :credit-notes/credit "Alacak"
   :credit-notes/download "PDF indir"
   :credit-notes/empty "Henüz alacak dekontu yok."
   :credit-notes/error "Alacak dekontları yüklenemedi."

   :offer/applied-automatically "Kredi eklediğinizde otomatik olarak uygulanır. O zamana kadar hoş geldin kredisi normal ücretle faturalandırılır."

   :rates/view "Tarifelerimizi görün"
   :rates/title "Tarifelerimize bir bakış"
   :rates/intro "Hizmet başına ne ücret aldığımızı burada görebilirsiniz. "
   :rates/intro-bold "Tüm fiyatlar ABD doları cinsindendir ve vergileri içermez (KDV hariç)."
   :rates/per-day "günlük"
   :rates/per-post "gönderi başına"
   :rates/per-image "görsel başına"
   :rates/per-days [:fn/str "{{:days}} gün için"]
   :rates/excl-vat "Tüm fiyatlar KDV hariç"
   :rates/off [:fn/str "%{{:percent}} İNDİRİM"]

   :service.storage-flat-fee/name "Sabit depolama ücreti"
   :service.storage-flat-fee/description "tüm görselleriniz, videolarınız vb. için"
   :service.instagram-connection/name "Instagram hesabı bağlantısı"
   :service.instagram-connection/description "Bir Instagram kullanıcı adı için sınırsız Hikaye ve Reels."
   :service.tiktok-post/name "TikTok gönderisi"
   :service.tiktok-post/description "TikTok'ta bir video veya görsel yayınlayın."
   :service.youtube-short/name "YouTube Short"
   :service.youtube-short/description "İşlenmiş bir videoyu YouTube Short olarak yayınlayın."
   :service.social-post/name "Sosyal medya gönderisi"
   :service.social-post/description "İşlenmiş bir videoyu veya görseli Facebook, Threads ve diğer bağlı platformlarda yayınlayın (X ayrıca ücretlendirilir)."
   :service.x-post/name "X gönderisi"
   :service.x-post/description "İşlenmiş bir videoyu X'te yayınlayın. X, API'si üzerinden yapılan her gönderi için ücret aldığından X gönderileri diğer sosyal medya gönderilerinden daha pahalıdır."
   :service.x-post-link/name "Bağlantılı X gönderisi"
   :service.x-post-link/description "Metninde bağlantı bulunan bir X gönderisi. X, bağlantılı gönderiler için çok daha fazla ücret alır."
   :service.ai-image/name "Yapay zeka görseli"
   :service.ai-image/description "Yapay zeka ile görsel oluşturma (Dall-e / Blackforest)."})
